import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/types/blockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import type { DividerComponentType } from '@unifyapps/defs/types/blocks';
import _pick from 'lodash/pick';
import Divider from './Divider';

class DividerBlockStateDefinition implements BlockStateDefinition {
  getBlockVersion() {
    return 0;
  }

  get type(): ComponentTypeUnionType {
    return 'Divider';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component as DividerComponentType, [
          'content',
          'appearance',
          'componentType',
        ]),
      }) as BlockStateUnionType;
  }

  getComponent() {
    return Divider;
  }
}

export default DividerBlockStateDefinition;
